import { InjectionToken } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { Observable } from 'rxjs';

export interface IImageFile {
	id?: string;
	fileContentType?: string;
}

export interface IImageDocument {
	id: string;
	contentType: string;
}

export interface IImageService {
	getImageUrl(imageId: string): Observable<SafeUrl>;
	findById(id: string): Observable<IImageDocument>;
}

export const IMAGE_SERVICE = new InjectionToken<IImageService>('ImageService', {
	providedIn: 'root',
	factory: (): IImageService => {
		throw new Error(
			'IMAGE_SERVICE is not provided. ' + 'Please provide an IImageService implementation in your app providers.'
		);
	},
});
